import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import {
  capitalizeFirstLetter,
  formateDate,
  formateDateWithMonth,
  getFormatedTime,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import {
  subscribeForPremium,
  subscriptionHistoryList,
  unsubscribeFromPremium,
  userDetails,
  UserActivityList,
  familyMembersList
} from "../../services/user.service";
import Swal from "sweetalert2";
import {
  MONTHS,
  SUBSCRIPTION_NAMES,
  SUBSCRIPTION_PRODUCT_IDS,
  SWAL_SETTINGS,
} from "../../../../utils/Constants";
import { SubscriptionHistoryList } from "../../services/subscriptionPlan.services";
import CustomRangepicker from "../../common/rangepicker";
import CustomPagination from "../../common/custompagination";
import ChatWindow from "./chatWindow";
import ChatSideBar from "./chatSideBar";
import Skeleton from "react-loading-skeleton";
import { useDispatch } from "react-redux";
import { setActivity } from "../../../../redux/slices/userActivitySlice";

const ViewUserActivity = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const params = useParams();
  // const [query] = useSearchParams();
  const dispatch = useDispatch();
  const [initialLoading, setInitialLoading] = useState(true);


  const [showdefault, setShowDefault] = useState({});
  const [familyMembers, setfamilyMembers] = useState({});
  const [statsupdate, setStatusUpdate] = useState("false");

  const [activityList, setActivityList] = useState([]);
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [loader, setLoader] = useState(true);
  const [resetdate, setResetDate] = useState(false);
  const [selectedFamily, setSelectedFamily] = useState(""); 
  // const breadcrumbs = [
  //     { title: t("link_dashboard"), url: "/admin/dashboard" },
  //     {
  //         title: t("User"),
  //         url: "/admin/user-management/user/list/1",
  //     },
  //     { title: t("View"), url: "" },
  // ];

  useEffect(() => {
    userDetails(params.id)
      .then((response) => {
        let d = new Date(response?.data?.date_of_birth) || new Date();
        const safeDate = new Date(
          d.getUTCFullYear(),
          d.getUTCMonth(),
          d.getUTCDate(),
        );
        response.data.date_of_birth = safeDate;

        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id, statsupdate]);

  useEffect(() => {
    familyMembersList(params.id)
      .then((response) => {
        setfamilyMembers(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id, statsupdate]);


  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        setInitialLoading(true); 
        const timer = setTimeout(() => {
        const formData = new FormData();
        formData.append("_id", params.id);
        formData.append("page", params.activityPgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        formData.append("family_member_id", selectedFamily); 
        UserActivityList(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setActivityList(
              data && data.data && data.data.list ? data.data.list : [],
            );
            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
            setInitialLoading(false);

            dispatch(setActivity(data?.data?.list[0] || null));
          })
          .catch((error) => {
            setLoader(false);
            setInitialLoading(false);
            console.log("error ====> ", error);
          });
        }, 1000);
      }
    }, 300);
    return () => clearTimeout(getData);
  }, [    
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.activityPgno,
    selectedFamily
  ]);

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    console.log(e);
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    // $("#defaultstatus")[0].selectedIndex = 0;
  };

  const viewfunction = (row) => {
    navigate(
      `/admin/user-management/user/view/user-details/${params.id}/${params.pgno}/chat-history/${params.activityPgno}?year=${row.year}&month=${row.month}`,
    );
  };

  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="row">
                <div className="animation_fade">
                  <div
                    className="card custom-card"
                    style={{ backgroundColor: "#eaedf7" }}
                  >
                    <div className="card-body" >
                      <div className="row row-sm">
                        {initialLoading  ? (
                          <div className="row row-gap-3 appointment-list">
                            {[...Array(4)].map((_, index) => (
                              <div   style={{ backgroundColor: "#fff", padding:"10px" }}>
                              <div key={index} className="col-md-6">
                                <div className="upcoming-appointment-card d-flex gap-3">
                                  <figure className="avatar avatar-md">
                                    <Skeleton circle height={50} width={50} />
                                  </figure>
                                  <figcaption className="d-flex flex-column gap-1">
                                    <Skeleton width="150px" height="20px" />
                                    <Skeleton width="100px" height="15px" />
                                    <Skeleton width="120px" height="15px" />
                                  </figcaption>
                                  <div className="appointment-card-action d-flex flex-column gap-2 justify-content-between">
                                    <Skeleton width="100px" height="15px" />
                                    <Skeleton width="80px" height="30px" />
                                  </div>
                                </div>
                              </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <>
                            <ChatSideBar
                              activityList={activityList}
                              prepareSearch={prepareSearch}
                              resetdate={resetdate}
                              resetFilter={resetFilter}
                              familyMembers={familyMembers}
                              selectedFamily={selectedFamily}
                              onFamilySelect={(id) => setSelectedFamily(id)}
                            />

                            <ChatWindow
                              activityList={activityList}
                              selectedFamily={selectedFamily}
                              familyMemberName={
                                Array.isArray(familyMembers.family_members)
                                  ? familyMembers.family_members.find(
                                      member => member._id === selectedFamily
                                    )?.name || ""
                                  : ""
                              }
                            />
                          </>
                        )}
                      </div>

                      {/* <div className="d-flex justify-content-between align-items-center mb-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="form-group mb-0 me-3">
                                                        <div className="form-group mb-0 rangepicker_container filter_design">
                                                            <i className="fa fa-search calender_icon"></i>
                                                            <input
                                                                type="search"
                                                                className="form-control"
                                                                value={globalsearch}
                                                                placeholder={t("input_placeholder_search")}
                                                                onChange={(e) => {
                                                                    setGlobalSearch(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="me-3">
                                                        <CustomRangepicker
                                                            GetDateRange={(e) => {
                                                            prepareSearch("createdAt", e);
                                                            }}
                                                            resetdate={resetdate}
                                                        />
                                                    </div>
                                                    
                                                    <button
                                                        type="reset"
                                                        value="Reset"
                                                        onClick={resetFilter}
                                                        className="btn btn-warning float-right mr-2"
                                                    >
                                                        {t("btn_reset_filter")}
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                                    <thead>
                                                        <tr>
                                                            <th className="position-relative select_head">
                                                                <span>{t("Month")}</span>
                                                            </th>

                                                            <th className="position-relative select_head">
                                                                <span>{t("Year")}</span>
                                                            </th>      

                                                            <th className="position-relative select_head">
                                                                <span>{t("Questions")}</span>
                                                            </th>
                                                            
                                                            <th className="action_head">{t("list_heading_action")}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loader ? (
                                                            <tr>
                                                            <td colSpan={14}>
                                                                <Loader />
                                                            </td>
                                                            </tr>
                                                        ) : (
                                                            <>
                                                            {activityList.length ? (
                                                                activityList.map((row, i) => {
                                                                return (
                                                                    <tr
                                                                    key={i}
                                                                    >
                                                                        <td>
                                                                            {MONTHS[row?.month-1] || 'N/A'}
                                                                        </td>
                                                                        <td>
                                                                            {row?.year || "N/A"}
                                                                        </td>
                                                                        <td>
                                                                            {row?.questions_count || "N/A"}
                                                                        </td>

                                                                        <td>
                                                                            <div className="d-flex">
                                                                            <button
                                                                                className="btn ripple btn-main-primary signbtn"
                                                                                onClick={() => {
                                                                                    viewfunction(row);
                                                                                }}
                                                                            >
                                                                                View Chat
                                                                            </button>

                                                                            </div>
                                                                        </td>

                                                                    </tr>
                                                                );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                <td colSpan={14} className="text-center">
                                                                    {t("msg_no_records")}
                                                                </td>
                                                                </tr>
                                                            )}
                                                            </>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        
                                            <div
                                                className=""
                                                id="example1_info"
                                                role="status"
                                                aria-live="polite"
                                            >
                                                <b>
                                                    {t("msg_total_records")} : {datalength ? datalength : "0"}
                                                </b>
                                            </div>

                                            {datalength && datalength > 0 ? (
                                                <CustomPagination
                                                    datalength={datalength}
                                                    itemperpage={itemperpage}
                                                    currentPage={page}
                                                    setPage={setPage}
                                                    pageRoute={[
                                                    {
                                                        name: "Psychic",
                                                        path: `/admin/user-management/user/view/${params.id}`,
                                                    },
                                                    ]}
                                                />
                                                ) : (
                                                ""
                                            )} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-2 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() => navigate(-1)}
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewUserActivity;
